import { NotificationEvent } from "@dashboard-v3/api";
import { Box, Button, Divider, Grid } from "@material-ui/core";
import {
  PropertyData,
  PropertyLabel,
} from "components/EmailEventDetails/styled";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import MalwareDetectedDetails from "./MalwareDetectedDetails";

type Props = {
  notification: NotificationEvent;
};

export default function StorageDetails(props: Props) {
  const { t } = useTranslation("notifications");
  const { data } = props.notification;

  if (!data) {
    return (
      <PropertyData color="textPrimary">
        {t("storage.dataUnavailable", {
          defaultValue: "Notification data not available",
        })}
      </PropertyData>
    );
  }

  if (props.notification.code === "malware-detected") {
    return <MalwareDetectedDetails notification={props.notification} />;
  }

  const details = data as StorageEventDetails;

  return (
    <>
      <Divider />
      <Grid container spacing={2} style={{ marginTop: "12px" }}>
        <Grid item lg={3}>
          <PropertyLabel>
            {t("storage.cloudStorage", { defaultValue: "Cloud storage" })}
          </PropertyLabel>
          <PropertyData>{details.storageType}</PropertyData>
        </Grid>
        <Grid item lg={3}>
          <PropertyLabel>
            {t("storage.user", { defaultValue: "User" })}
          </PropertyLabel>
          <PropertyData>{details.userId}</PropertyData>
        </Grid>
        <Grid item xs={12}>
          <Box mt={2}>
            <Button
              component={RouterLink}
              to="/integrations?tab=ACCOUNTS"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="outlined"
            >
              {t("storage.goToAccounts", {
                defaultValue: "Go to storage accounts",
              })}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

type StorageEventDetails = {
  applicationId: string;
  storageType: string;
  userId: string;
};
